/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: CompanyRevisionsSelect.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/22 @ 166
 * ---
 * Description:
 */

import {MyLabelRevision} from "../../../../entities";
import {useEffect, useState} from "react";
import {MyLabelAuthFeature} from "../../../../store/features/mylabel/auth/MyLabelAuthFeature";
import {mleDomainGqlClient} from "../../../../api/domain";
import {GET_REVISIONS_INFO} from "../../../../api/domain/queries.gql";
import {ML_LOGIN} from "../../../../api/domain/mutations.gql";
import {RevisionSelect} from "./RevisionSelect";

interface Props {
    onRevisionSelect: (recipe: MyLabelRevision) => void;
    onRevisionLoaded: (revs: MyLabelRevision[]) => void;
    onStartLoading: () => void;
    disabled?: boolean;
    companyId: number;
    selectedRevision?: MyLabelRevision;
    onNoRevision: () => void;
}

/**
 * Componente per selezionare una revisione appartenente ad una specifica Company
 * NOTA: Carica in automatico le revisioni a partire dalla company (passata tramite id)
 * @param props
 * @constructor
 */
export const CompanyRevisionsSelect = (props: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [revisions, setRevisions] = useState<MyLabelRevision[]>([]);

    useEffect(() => {
            (async () => {
                setIsLoading(true);
                props.onStartLoading();
                const key = window.localStorage.getItem(MyLabelAuthFeature.__usr_key);
                const pwd = window.localStorage.getItem(MyLabelAuthFeature.__usr_pwd);

                await mleDomainGqlClient.mutate({
                    mutation: ML_LOGIN,
                    variables: {
                        username: key,
                        password: pwd
                    }
                });

                // Load revisions meta
                const revisionsList =
                    (await mleDomainGqlClient.query({
                        query: GET_REVISIONS_INFO,
                        variables: {
                            companyId: props.companyId
                        },
                        fetchPolicy: 'no-cache'
                    })).data.getLabelRevisions as MyLabelRevision[];

                // Check returned result
                if (revisionsList) {
                    setRevisions(revisionsList);
                    props.onRevisionLoaded(revisionsList);
                }

                if (revisionsList && revisionsList.length == 0)
                    props.onNoRevision();

                setIsLoading(false);
            })();
        },
        [setRevisions, setIsLoading, props.companyId]);

    return (
        <RevisionSelect
            selectedValue={props.selectedRevision}
            onChange={(value) => {
                props.onRevisionSelect(value);
            }}
            data={revisions}
            isLoading={isLoading}
            disabled={revisions.length == 0}/>
    );
}